// extracted by mini-css-extract-plugin
export default {"item":"Deliver_item__vkOgH","item-wp":"Deliver_item-wp__6HwGC"};